export enum LegacySystemIdpKey {
    BayernId = 'bayern_id',
    BundId = 'bund_id',
    Muk = 'muk',
    ShId = 'sh_id',
}

export const LegacySystemIdpKeys = [
    LegacySystemIdpKey.BayernId,
    LegacySystemIdpKey.BundId,
    LegacySystemIdpKey.Muk,
    LegacySystemIdpKey.ShId,
];